export default (order) => {
  return order + 1;
};
